var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_c('PageTitle',{staticClass:"page-home-title",attrs:{"fontSize":"35","icon":"fa fa-cogs","title":"Central de Aplicações"}})],1),_c('Applications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }